// enums / lookups / constants for the dochub stuff
// these match the enums in backend but have more metadata for frontend
import { suppliosApi } from "@/js/api-service";
import orderBy from 'lodash/orderBy';


const LAYOUT_TYPES = [
    // {
    //     value: 'SMALL_CARDS',
    //     label: 'Small Cards',
    //     icon: 'grid3x3-gap-fill',
    // },
    
    // {
    //     value: 'LARGE_CARDS',
    //     label: 'Large Cards',
    //     icon: 'grid-fill',
    // },
    // {
    //     value: 'FULL_CARDS',
    //     label: 'Full Cards',
    //     icon: 'view-list',
    // },
    {
        value: 'GRID',
        label: 'Grid',
        icon: 'grid3x3-gap-fill',
    },
    {
        value: 'LIST',
        label: 'List',
        icon: 'list',
    },
];

const LAYOUT_TYPES_BY_VALUE = Object.fromEntries(LAYOUT_TYPES.map((x) => [x.value, x]));


const ORDERING_TYPES = [
    {
        value: 'DEFAULT',
        label: 'Default',
        canDragResources: true,
    },
    {
        value: 'NAME',
        label: 'Name',
        canDragResources: false,
    },
    {
        value: 'SORT_ORDER',
        label: 'Manual Order',
        canDragResources: true,
    },
    {
        value: 'CREATED_ASC',
        label: 'Created (Oldest First)',
        canDragResources: false,
    },
    {
        value: 'CREATED_DESC',
        label: 'Created (Newest First)',
        canDragResources: false,
    },
    {
        value: 'NO_GROUP',   // special one for the 'NO_GROUP' group
        label: 'Manual Order',
        canDragResources: true,
    },
];

const ORDERING_TYPES_BY_VALUE = Object.fromEntries(ORDERING_TYPES.map((x) => [x.value, x]));

const NO_GROUP_DATA = {
    id: 'NO_GROUP',  // this should match the backend.... data will come from API with this key if no group
    name: 'Other Items',
    description: '',
    sort_order: 10000000,
    layout_type: 'LIST',
    ordering_type: 'NO_GROUP',
};

// HELPER TO FETCH THINGS FROM API - for edit and view components

function makeLocalGroup(group, resources, idx) {
    // make our local version of the groups, with resources attached
    console.log('makeLocalGroup', group.name);
    const isNoGroup = group.id === NO_GROUP_DATA.id;
    return {
        ...group,
        uniqueId: `dochubgroup-${group.id}`,
        resources: resources,
        canDragResources: ORDERING_TYPES_BY_VALUE[group.ordering_type].canDragResources,
        canEdit: !isNoGroup,  // editable? (only used in manager component)
        localIndex: idx || 0,  // only used in manager component
    };
}

async function fetchGroupsWithResources({forManager = false, onlyPublished = false} = {}) {
    // pass in forManager=true to get extra data for the manager component
    // otherwise, leave off or set false to get for viewer component
    // LET ANY ERROR GET THROWN UP TO CALLER
    console.log('fetchGroupsWithResources - forManager:', forManager);
    let resp;
    if (forManager) {
        resp = await suppliosApi.dochubGroupManage.list_resources_and_groups();
    } else {
        resp = await suppliosApi.dochubResource.list_resources_and_groups(onlyPublished);  // pass forPublished=true (remove? should be hard-coded true)
    }
    const resourcesByGroupId = resp.data.resources_by_group_id; 
    const rawApiGroups = Array.isArray(resp.data.groups) ? resp.data.groups : [];
    const sortedRawApiGroups = orderBy(rawApiGroups, ['sort_order'], ['asc']);  // sorted correctly, but without extra local attrs
    const finalGroups = sortedRawApiGroups.map((g, idx) => {
        const resourcesForGroup = resourcesByGroupId[g.id] || [];
        return makeLocalGroup(g, resourcesForGroup, idx);
    });
    // add our special "no group" group - ONLY IF NEEDED... if forManager is true, or if we have any resources without a group!
    const isNoGroupNeeded = false;  // OLD - should not have any longer - forManager || resourcesByGroupId[NO_GROUP_DATA.id];
    if (isNoGroupNeeded) {
        const noGroupIndex = finalGroups.length;  // add it as the last one
        const noGroupResources = resourcesByGroupId[NO_GROUP_DATA.id] || [];
        finalGroups.push(makeLocalGroup(NO_GROUP_DATA, noGroupResources, noGroupIndex));
    }
    return finalGroups;
}



export {
    LAYOUT_TYPES,
    LAYOUT_TYPES_BY_VALUE,
    ORDERING_TYPES,
    ORDERING_TYPES_BY_VALUE,
    NO_GROUP_DATA,
    fetchGroupsWithResources,
}